module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/@oppein-lib/op-upload/~/axios/index.js
// module id = 1166
// module chunks = 67